import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Button } from "@material-ui/core";
import { buildZendeskLink } from "src/store/adminHtml/selector";
import { openZendeskWithSSO } from "src/utils/zendeskSso";
import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "src/store/system/selector";
import theme from "src/theme";

const useStyles = makeStyles((theme) => ({
  minimalMarginBottom: {
    marginBottom: "10px",
  },
  importantText: {
    fontWeight: theme.typography.fontWeightBold,
  },
  headerText: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  textField: {
    marginTop: theme.spacing(1),
    width: "100%",
  },
}));

interface NotUsingItDialogProps {
  cancellationReason: string;
  setCancellationReason: (reason: string) => void;
}

function NotUsingItDialog(props: NotUsingItDialogProps) {
  const classes = useStyles();
  const user = useSelector(selectUser);
  if (!user) return null;

  return (
    <div>
      <Typography variant="h4" className={classes.headerText}>
        We’d love the chance to walk you through exactly how My Reseller Genie
        can help your business.
      </Typography>
      <Box
        sx={{ width: "100%" }}
        flexDirection="row"
        alignItems="start"
        justifyContent="center"
        pb={theme.spacing(0.5)}
      >
        <div style={{ marginRight: "1rem" }}>
          <Typography variant="body1">
            Got burning questions? Contact support now and we’ll provide you an
            answer in 24 hours or less.
          </Typography>
          <div style={{ paddingTop: "1rem" }}>
            <Button
              color="primary"
              variant="contained"
              onClick={() =>
                openZendeskWithSSO(
                  buildZendeskLink(
                    user,
                    "I have questions on how to use MRG",
                    "Please use this description box to outline the problems you are facing below:",
                    "cancellationReason:notUsingItAction",
                    "cancelation"
                  )
                )
              }
            >
              Contact Support
            </Button>
          </div>
        </div>
      </Box>
      <div style={{ paddingTop: "1rem" }}>
        <Typography>
          <Box component="span" fontWeight="fontWeightMedium">
            Before you click Cancel Subscription,
          </Box>{" "}
          please let us know why you've decided to not use My Reseller Genie:
        </Typography>
      </div>
      <TextField
        id="filled-basic"
        label="Describe the Reason"
        variant="filled"
        className={classes.textField}
        value={props.cancellationReason}
        onChange={(event) => {
          props.setCancellationReason(event.target.value);
        }}
      />
    </div>
  );
}

export default NotUsingItDialog;
